import { useState, useEffect } from "react";
import { FaChevronLeft } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Modal from "../../components/Modal";
import AddVehicle from "../../forms/vehicle/AddVehicle";
import UpdateInsuranceStatus from "../../forms/vehicle/UpdateInsuranceStatus";
import AssignVehicleToDriver from "../../forms/vehicle/AssignVehicleToDriver";

import { GetVehicle } from "../../Services";

const VehicleList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { driver } = location.state || {};

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [editingVehicle, setEditingVehicle] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: "id", direction: "asc" });

  useEffect(() => {
    const fetchDispatchers = async () => {
      setLoading(true);
      try {
        const data = await GetVehicle.fetchVehicle();
        setVehicles(Array.isArray(data.data) ? data.data : []);

        // console.log("Vehicles", data);
      } catch (error) {
        console.error("Error fetching dispatcher:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchDispatchers();
  }, []);

  // Fetch vehicles
  //   useEffect(() => {
  //     const fetchVehicles = async () => {
  //       try {
  //         const res = await axios.get(
  //           `https://binberu.idaprocharity.com/api/v1/admin/get-vehicle-list`
  //         );
  //         const data = Array.isArray(res.data) ? res.data : res.data.data || [];
  //         setVehicles(data);
  //       } catch (error) {
  //         console.error("Error fetching vehicles:", error);
  //         toast.error("Failed to fetch vehicles", {
  //           position: "top-right",
  //           autoClose: 3000,
  //         });
  //       } finally {
  //         setLoading(false);
  //       }
  //     };

  //     fetchVehicles();
  //   }, [driver?.id]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Handle sort
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sorted = [...vehicles].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });
    setVehicles(sorted);
  };

  // Handle delete
  const handleDelete = async (vehicleId) => {
    if (!window.confirm("Are you sure you want to delete this vehicle?"))
      return;

    try {
      await axios.delete(
        `https://binberu.idaprocharity.com/api/v1/admin/delete-vehicle/${vehicleId}`
      );
      setVehicles((prev) => prev.filter((v) => v.id !== vehicleId));
      toast.success("Vehicle deleted successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
    } catch (error) {
      console.error("Error deleting vehicle:", error);
      toast.error(error.response?.data?.message || "Failed to delete vehicle", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  // Handle insurance status click
  const handleInsuranceClick = (vehicle) => {
    setSelectedVehicle(vehicle);
    setModalType("insurance");
    setShowModal(true);
  };

  // Handle assign vehicle to a driver
  const handleAssignClick = (vehicle) => {
    setSelectedVehicle(vehicle);
    // console.log("selecte vehicle : ", vehicle);
    setModalType("assign");
    setShowModal(true);
  };

  // Handle add/edit vehicle
  const handleAddEditVehicle = (vehicle = null) => {
    setEditingVehicle(vehicle);
    setModalType(vehicle ? "edit" : "add");
    setShowModal(true);
  };

  const renderVehicles = () => {
    if (loading) return <p>Loading vehicles...</p>;
    if (vehicles.length === 0) return <p>No vehicles found for this driver.</p>;

    return (
      <table className="table table-striped">
        <thead>
          <tr>
            <th>ID</th>
            <th>Plate No</th>
            <th>Model</th>
            <th>Year</th>
            <th>Color</th>
            <th>Type</th>
            <th>Owner</th>
            <th>Insurance Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {vehicles.map((v) => (
            <tr key={v.id}>
              <td>{v.id}</td>
              <td>{v.plate_no}</td>
              <td>{v.model}</td>
              <td>{v.year}</td>
              <td>{v.color}</td>
              <td>{v.vehicle_type}</td>
              <td>{v.owner_name}</td>
              <td>
                <span
                  className="insurance-status"
                  style={{
                    color: v.insurance_status ? "green" : "red",
                    backgroundColor: v.insurance_status ? "#d4edda" : "#f8d7da",
                    cursor: "pointer",
                  }}
                  onClick={() => handleInsuranceClick(v)}
                >
                  {v.insurance_status ? "Active" : "Expired"}
                </span>
              </td>
              <td>
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => handleAddEditVehicle(v)}
                  data-bs-toggle="tooltip"
                  title="Edit"
                  aria-label="Edit vehicle"
                >
                  <i className="fas fa-edit" />
                </button>
                <button
                  className="btn btn-sm btn-outline-danger ml-2"
                  onClick={() => handleDelete(v.id)}
                  data-bs-toggle="tooltip"
                  title="Delete"
                  aria-label="Delete vehicle"
                >
                  <i className="fas fa-trash" />
                </button>
                {v.assigned ? (
                  <button
                    className="btn btn-sm btn-outline-info ml-2"
                    onClick={() => {
                      // console.log(v); // Log the selected vehicle to the console
                      navigate("/get-driver-by-vehicle", {
                        state: { vehicleId: v.id }, // Pass the vehicle ID
                      });
                    }}
                    data-bs-toggle="tooltip"
                    title="Show Details"
                    aria-label="Show vehicle details"
                  >
                    Show Details
                  </button>
                ) : (
                  <button
                    className="btn btn-sm btn-outline-success ml-2"
                    onClick={() => handleAssignClick(v)} // Pass vehicle to handleAssignClick
                    data-bs-toggle="tooltip"
                    title="Assign"
                    aria-label="Assign vehicle"
                  >
                    Assign
                  </button>
                )}{" "}
                <button
                  className="btn btn-sm btn-link"
                  onClick={() =>
                    navigate("/driver-document", { state: { driver } })
                  }
                >
                  Document
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <div className="content-wrapper p-4">
      <h2 className="text-2xl font-bold">
        Vehicle list of {driver ? driver.name : "Driver"} /{" "}
        {driver ? driver.email : "Driver"}
      </h2>
      <div className="card">
        <div className="card-header">
          {/* <div className=""> */}
          <button
            type="button"
            onClick={() => handleAddEditVehicle()}
            className="btn btn-sm btn-primary flex items-center gap-2"
            data-bs-toggle="tooltip"
            title="Add Vehicle"
            aria-label="Add Vehicle"
          >
            <i className="fas fa-car" /> Add Vehicle
          </button>
          {/* </div> */}
        </div>

        {showModal && (
          <Modal showModal={showModal} setShowModal={setShowModal}>
            {modalType === "add" || modalType === "edit" ? (
              <AddVehicle
                editingVehicle={editingVehicle}
                setEditingVehicle={setEditingVehicle}
                setVehicles={setVehicles}
                setShowModal={setShowModal}
                driverId={driver?.id}
              />
            ) : modalType === "insurance" ? (
              <UpdateInsuranceStatus
                vehicle={selectedVehicle}
                setVehicles={setVehicles}
                setShowModal={setShowModal}
              />
            ) : modalType === "assign" ? (
              <AssignVehicleToDriver
                vehicle={selectedVehicle}
                setVehicles={setVehicles}
                setShowModal={setShowModal}
              />
            ) : null}
          </Modal>
        )}

        <div className="card-body p-4">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex gap-4">
              <button type="button" className="btn btn-outline-secondary">
                CSV
              </button>
              <button type="button" className="btn btn-outline-secondary ml-2">
                Excel
              </button>
              <button type="button" className="btn btn-outline-secondary ml-2">
                PDF
              </button>
            </div>{" "}
            <input
              type="text"
              className="form-control ml-4"
              placeholder="Search..."
              style={{ width: "300px" }}
            />
          </div>

          {renderVehicles()}
        </div>

        <div className="card-footer clearfix">
          <ul className="pagination pagination-sm m-0 float-right">
            <li className="page-item">
              <a
                className="page-link"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  if (currentPage > 1) handlePageChange(currentPage - 1);
                }}
              >
                &laquo;
              </a>
            </li>
            {[...Array(totalPages).keys()].map((page) => (
              <li
                className={`page-item ${
                  currentPage === page + 1 ? "active" : ""
                }`}
                key={page + 1}
              >
                <a
                  className="page-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handlePageChange(page + 1);
                  }}
                >
                  {page + 1}
                </a>
              </li>
            ))}
            <li className="page-item">
              <a
                className="page-link"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  if (currentPage < totalPages)
                    handlePageChange(currentPage + 1);
                }}
              >
                &raquo;
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default VehicleList;
